/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LocalAccountRegistrationRequest
 */
export interface LocalAccountRegistrationRequest {
    /**
     * 
     * @type {string}
     * @memberof LocalAccountRegistrationRequest
     */
    birthDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocalAccountRegistrationRequest
     */
    birthNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocalAccountRegistrationRequest
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocalAccountRegistrationRequest
     */
    lastName?: string | null;
}

/**
 * Check if a given object implements the LocalAccountRegistrationRequest interface.
 */
export function instanceOfLocalAccountRegistrationRequest(value: object): value is LocalAccountRegistrationRequest {
    return true;
}

export function LocalAccountRegistrationRequestFromJSON(json: any): LocalAccountRegistrationRequest {
    return LocalAccountRegistrationRequestFromJSONTyped(json, false);
}

export function LocalAccountRegistrationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocalAccountRegistrationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'birthDate': json['birth_date'] == null ? undefined : json['birth_date'],
        'birthNumber': json['birth_number'] == null ? undefined : json['birth_number'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
    };
}

export function LocalAccountRegistrationRequestToJSON(json: any): LocalAccountRegistrationRequest {
    return LocalAccountRegistrationRequestToJSONTyped(json, false);
}

export function LocalAccountRegistrationRequestToJSONTyped(value?: LocalAccountRegistrationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'birth_date': value['birthDate'],
        'birth_number': value['birthNumber'],
        'first_name': value['firstName'],
        'last_name': value['lastName'],
    };
}

